export const passwordRegex =
	/^(?=.*[a-zA-Z])(?=.*[\d])[a-zA-Z\d!@#$%^&*()_+={}|[\]\\';:\/?,.~`-]{7,}$/;